<template>
  <div class="card-body">
    <div class="brand-wrapper">
      <img src="@/assets/images/logo.svg"
        alt="logo"
        class="logo">
    </div>
    <p class="login-card-description">Aanmelden <small>met office 365</small></p>
    <p>Je wordt doorgestuurd naar Microsoft om aan te melden.</p>
    <a
      class="btn btn-block login-btn mb-4"
      :href="loginUrl">
      Doorgaan
    </a>
    <router-link
        :to="{name: 'choose'}"
      class="forgot-password-link">
      <span class="mdi mdi-arrow-left"></span> Andere methode
    </router-link>
  </div>
</template>

<script>
import { addDeviceNameToUrl } from '@/utils/device';

export default {
  name: 'login',
  computed: {
    loginUrl() {
      const resolved = this.$router.resolve({ name: 'choose' }).href;
      const redirectUri = `${window.location.origin}${resolved}`;
      const loginUrl = `${process.env.VUE_APP_BASE_URL}/v1/login/365/oidc?redirect_uri=${encodeURIComponent(redirectUri)}`;
      return addDeviceNameToUrl(loginUrl);
    },
  },
  mounted() {
    window.location.href = this.loginUrl;
  },
};
</script>

<style lang="scss">
</style>
